import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@shadcn/components/ui/card';
import { Zap, Play, AlertTriangle, CheckCircle } from 'lucide-react';
import automationApi from '../../services/automationApi';

const StatCard = ({ icon: Icon, label, value, iconColor }) => (
  <Card>
    <CardContent className="p-4">
      <div className="flex items-center gap-3">
        <div className={`p-2 rounded-lg ${iconColor}`}>
          <Icon size={20} />
        </div>
        <div>
          <p className="text-sm text-gray-500">{label}</p>
          <p className="text-2xl font-bold">{value ?? '-'}</p>
        </div>
      </div>
    </CardContent>
  </Card>
);

const DashboardStats = ({ refreshKey = 0 }) => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
    automationApi.getStats()
      .then(res => setStats(res))
      .catch(() => setError(true));
  }, [refreshKey]);

  if (error) {
    return (
      <div className="text-sm text-red-500 bg-red-50 border border-red-200 rounded-lg p-3">
        Failed to load dashboard stats.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard
        icon={Zap}
        label="Active Workflows"
        value={stats ? `${stats.rules?.enabled ?? 0}` : undefined}
        iconColor="bg-blue-50 text-blue-600"
      />
      <StatCard
        icon={Play}
        label="Executions"
        value={stats?.executions?.total}
        iconColor="bg-green-50 text-green-600"
      />
      <StatCard
        icon={AlertTriangle}
        label="Failed"
        value={stats?.executions?.failed}
        iconColor="bg-red-50 text-red-600"
      />
      <StatCard
        icon={CheckCircle}
        label="Success Rate"
        value={stats?.executions?.successRate != null ? `${stats.executions.successRate}%` : undefined}
        iconColor="bg-emerald-50 text-emerald-600"
      />
    </div>
  );
};

export default DashboardStats;
